/**
 * Extracts and formats user-friendly error messages from API errors
 * @param {Error|Object} err - The error object from API call
 * @returns {string} User-friendly error message
 */
export function extractError(err) {
  if (!err) {
    return "Unable to reach the analytics service. Please check your connection and try again.";
  }

  // Check for axios response error
  const errorMessage = err?.response?.data?.detail || err?.response?.data?.message || err?.message || String(err);
  
  // Map common database errors to user-friendly messages
  if (typeof errorMessage === 'string') {
    // Database column errors
    if (errorMessage.includes("Unknown column") || errorMessage.includes("42S22")) {
      return "The data structure has changed. Please refresh the page or contact support if the issue persists.";
    }
    
    // Connection errors
    if (errorMessage.includes("ECONNREFUSED") || errorMessage.includes("Network Error")) {
      return "Unable to connect to the server. Please check your internet connection and try again.";
    }
    
    // Timeout errors
    if (errorMessage.includes("timeout") || errorMessage.includes("ETIMEDOUT")) {
      return "The request took too long to complete. Please try again.";
    }
    
    // 404 errors
    if (errorMessage.includes("404") || err?.response?.status === 404) {
      return "The requested resource was not found. Please try again later.";
    }
    
    // 500 errors
    if (errorMessage.includes("500") || err?.response?.status === 500) {
      return "A server error occurred. Please try again later or contact support if the problem continues.";
    }
    
    // 401/403 errors
    if (errorMessage.includes("401") || err?.response?.status === 401) {
      return "Your session has expired. Please refresh the page to log in again.";
    }
    
    if (errorMessage.includes("403") || err?.response?.status === 403) {
      return "You don't have permission to access this resource.";
    }
    
    // Generic database errors
    if (errorMessage.includes("SQL") || errorMessage.includes("database") || errorMessage.match(/\d{4}\s*\(/)) {
      return "A data error occurred. Please try again or contact support if the issue persists.";
    }
  }
  
  // If we have a reasonable error message, return it (but truncate if too long)
  if (errorMessage && errorMessage.length < 200) {
    return errorMessage;
  }
  
  // Default fallback
  return "An unexpected error occurred. Please try again or contact support if the problem continues.";
}

